import type { EditorState } from "../../vendor/src/features/remotion-editor/editor/state/types";
export type EditOwnership = {
  base: EditorState;
  token: string;
  established: boolean;
  lastInput: EditorState | null;
};
export const ownsEdit = (owner: EditOwnership, state: EditorState) =>
  state === owner.lastInput ||
  state.documentMutationOwner === owner.token ||
  (!owner.established && state.undoableState === owner.base.undoableState);
export const hasPendingTimelineEdit = (state: EditorState) =>
  state.timelineMoveActive === true ||
  Boolean(state.timelineInputOwner) ||
  state.itemsBeingTrimmed.length > 0 ||
  Object.values(state.undoableState.items).some(
    (item) => item.isDraggingInTimeline,
  );
